


























import Vue from 'vue'
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";
import {ExtensionViewModel} from "@/models/ExtensionViewModel";
import ExtensionForm from "@/components/extensions/ExtensionForm.vue";
import {UserViewModel} from "@/models/UserViewModel";

export default Vue.extend( {
  name: "ExtensionNew",
  components: {
    ExtensionForm,
  },
  data(): {
    itemId: number
    extension: ExtensionViewModel
    formSaving: boolean
    workAreaList: any[]
  }{
    return {
      itemId: 0 ,
      extension: {
        createdByName: "" ,
        createdByTitle: "" ,
        createdByEmail: "" ,
        municipalityName: "" ,
        municipalityAbbreviation: "" ,
      } as ExtensionViewModel,
      formSaving: false,
      workAreaList: []
    }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
  mounted() {
    this.getWorkAreaList();
    this.addDataToExtension();
  },
  methods: {
    async getWorkAreaList() {
      const results = await this.axios.get('/Lookups/GetWorkAreas');
      this.workAreaList = results.data;
    },
    async createExtension() {
      console.log("*** createExtension method of ExtensionEdit")
      console.log( this.extension );
      console.log( this.extension.scheduledWorkDate.toString() );
      try {

        this.formSaving = true;

        let tempWA = this.workAreaList.find( w => w.abbreviation === this.extension.workAreaAbbreviation );
        this.extension.workArea = tempWA.displayValue;
        this.extension.workAreaType = tempWA.category;

        const result = await this.axios.post('/Extensions/PostExtension', this.extension , {headers: { "Content-Type": "application/json" } } );
        const data = result.data as unknown as ReturnDataViewModel;
        let returnedId = data.idReturned.toString();

        if (result.status === 200) {
          await this.$router.push( { name: "extensions-detail", params: { id: returnedId.toString() } } );
        }

      } catch ( err ) {
        if ( err.response.status === 400 || err.response.status === 403 || err.response.status === 404 || err.response.status === 409 ) {
          console.log( err.response.data.message )
        }
      } finally {
        this.formSaving = false;
      }
    },
    addDataToExtension() {
      this.extension.createdByEmail = this.loggedInUser.email;
      this.extension.createdByTitle = this.loggedInUser.title;
      this.extension.createdByName = this.loggedInUser.fullName;
      this.extension.municipalityName = this.loggedInUser.municipality;
      this.extension.municipalityAbbreviation = this.loggedInUser.municipalityAbbreviation;
      this.extension.statusCode = "DRFT";
      this.extension.statusText = "Draft";
    },
  },
} )

